module.exports = "//cdn.scentbird.com/assets/frontbird-site/images/mobile_ef341c.jpg";